import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import * as a from './actions';
import * as e from './effects';
import { questionnaireFeature } from './reducers';
import * as s from './selectors';

export const feature = questionnaireFeature;
export const effects = e.list;
export const selectors = s.list;
export const actions = a.list;

export function provideQuestionnaireStore(): EnvironmentProviders {
  return makeEnvironmentProviders([provideState(feature), provideEffects(effects), actions, selectors]);
}
